import { Component, OnInit } from '@angular/core';
import { ApexAxisChartSeries, ApexChart, ApexDataLabels, ApexPlotOptions, ApexXAxis } from 'ng-apexcharts';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';
import { SalesPersonService } from 'src/app/services/crew-services/sales-person.service';
import { ClientTaskService } from 'src/app/services/task/client-task.service';
import DateUtils from 'src/app/utils/date';


export type ApexChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  colors: string[]
};

@Component({
  selector: 'app-activity-outcome-report',
  templateUrl: './activity-outcome-report.component.html',
  styleUrls: ['./activity-outcome-report.component.css']
})

export class ActivityOutcomeReportComponent implements OnInit {

  dummyArray = [
    { activity: "Email", positive: 76, neutral: 100, negative: 50 },
      { activity: "Call", positive: 300, neutral: 420, negative: 288 },
      { activity: "SMS", positive: 234, neutral: 330, negative: 250 },
      { activity: "Note", positive: 21, neutral: 80, negative: 100 },
  ];

  dataTableOutcome = {
    dataChangedObs: new BehaviorSubject(null),
    heads: [
      { title: "checkbox", key: "checkbox" },
      // { title: "ID", key: "id" },
      { title: "Activity", key: "activity" },
      { title: "Positive", key: "positive" },
      { title: "Neutral", key: "neutral" },
      { title: "Negative", key: "negative" },
    ],
    rows: [],
    options: {
      datePipe: {},
      singleActions: [],
      bulkActions: [],
    },
  };

  public chartOptions = {
    series: [
      {
        name: "positive",
        data: [],
      },
      {
        name: "neutral",
        data: []
      },
      {
        name: "negative",
        data: []
      },
    ],
    chart: {
      type: "bar",
      height: 270
    },
    plotOptions: {
      bar: {
        horizontal: false,
        distributed: true,
        columnWidth: '30%',
      }
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      // categories: ['Jan', 'Feb', 'March', 'April', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      title: {
        text: 'Result',
      },
    },
    yaxis: {
      categories: ['Email', 'SMS', 'Call', 'Note'],
      title: {
        text: 'Activity Type',
      },
    },
    colors: [
      "rgb(255,177,193))", "rgb(154,208,245)", "rgb(255,230,170)",
      "rgb(165,223,223)", "rgb(204,178,255)"
    ]
  };
  dateRange;
  dateUtil = new DateUtils;
  barChartYear = 2020;


  constructor(
    private toastr: ToastrService,
    private taskSvc: ClientTaskService,
    private salesPersonSvc: SalesPersonService,
  ) {
   }

   async ngOnInit() {
     this.dataTableOutcome.rows = this.dummyArray;
    this.dummyArray.forEach(data => {
      this.chartOptions.series[0].data.push(data.positive);
      this.chartOptions.series[1].data.push(data.neutral);
      this.chartOptions.series[2].data.push(data.negative);

    });
    this.dateRange = this.dateUtil.getDefReportDateRange();
  }


}
